export const billPaymentStatus = {
  pending: 'Pendente',
  paid: 'Pago',
  failed: 'Falha',
  expired: 'Expirado',
  canceled: 'Cancelado',
};
